import { useState, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import dayjs from 'dayjs'
import { withRouterProps } from '../../../../utils'
import { Drawer, Loading } from '../../../../components'
import { aliveInvestments } from '../investmentUtils'
import { BalanceCaption, GroupList } from './InvestmentRowStyle'
import InstitutionalInvestmentsGroup from './InstitutionalInvestmentsGroup'
import EditInvestment from '../EditInvestment'
import AddBalance from '../AddBalance'
import AvailableInvestments from './AvailableInvestments'

const InstitutionalInvestmentsDisplay = props => {
  const [editInvestment, setEditInvestment] = useState(null)
  const [addBalance, setAddBalance] = useState(null)
  const toggleEdit = securityId => setEditInvestment(securityId)
  const toggleAdd = securityId => setAddBalance(securityId)
  const closeDrawer = () => {
    setEditInvestment(null)
    setAddBalance(null)
  }
  const { id } = props.match.params

  const {
    features: { editInstitutionalAccount },
    institutionalAccount,
  } = props.store

  const {
    investments,
    investedInvestments,
    preTaxInvestments,
    rothInvestments,
    afterTaxInvestments,
    notInvestedInvestments,
    preTaxBalance,
    rothBalance,
    afterTaxBalance,
    availableInvestments,
    getAvailableInvestments,
  } = props.account
  const [loadingAvailableInvestments, setLoadingAvailableInvestments] = useState(true)

  useEffect(() => {
    const fetchAvailableInvestments = async () => {
      try {
        if (editInstitutionalAccount) {
          await getAvailableInvestments()
        }
        setLoadingAvailableInvestments(false)
      } catch (error) {
        setLoadingAvailableInvestments(false)
        console.error(error)
      }
    }
    fetchAvailableInvestments()
  }, [editInstitutionalAccount, getAvailableInvestments])

  const investmentDates = aliveInvestments(investments).map(investment =>
    dayjs(investment.dateOfUserInfo || new Date()).valueOf()
  )

  const canEdit = editInstitutionalAccount
  const mostRecentInvestmentDate = dayjs(Math.min(...investmentDates)).format('M/D/YYYY')
  const isInstitutionalAccount = Number(id) === institutionalAccount?.id

  return (
    <div>
      <GroupList>
        {investedInvestments.length > 0 && (
          <BalanceCaption>Data as of {mostRecentInvestmentDate}</BalanceCaption>
        )}

        {preTaxInvestments.length > 0 && (
          <InstitutionalInvestmentsGroup
            balance={preTaxBalance}
            balanceLabel='Pre-tax balance'
            investments={preTaxInvestments}
            title='Pre-tax investments'
            canEdit={canEdit}
            toggleEdit={toggleEdit}
            accountId={id}
          />
        )}

        {rothInvestments.length > 0 && (
          <InstitutionalInvestmentsGroup
            balance={rothBalance}
            balanceLabel='Roth balance'
            investments={rothInvestments}
            title='Roth investments'
            canEdit={canEdit}
            toggleEdit={toggleEdit}
            accountId={id}
          />
        )}

        {afterTaxInvestments.length > 0 && (
          <InstitutionalInvestmentsGroup
            balance={afterTaxBalance}
            balanceLabel='After-tax balance'
            investments={afterTaxInvestments}
            title='After-tax investments'
            canEdit={canEdit}
            toggleEdit={toggleEdit}
            accountId={id}
            showCostBasisHelp
          />
        )}

        {notInvestedInvestments.length > 0 && (
          <InstitutionalInvestmentsGroup
            hideBalance
            investments={notInvestedInvestments}
            title='Other available investment options'
            toggleEdit={toggleEdit}
          />
        )}
      </GroupList>
      {loadingAvailableInvestments && <Loading></Loading>}

      {editInstitutionalAccount && isInstitutionalAccount && availableInvestments.length > 0 && (
        <AvailableInvestments
          displayTitle={!notInvestedInvestments.length}
          availableInvestments={availableInvestments}
          toggleAdd={toggleAdd}
        />
      )}

      <Drawer
        active={Boolean(editInvestment || addBalance)}
        title={editInvestment ? 'Edit investment' : addBalance ? 'Add balance' : ''}
        maxWidth='700px'
        width='60%'
        responsiveWidth
        onOverlayClick={closeDrawer}
        onEscKeyDown={closeDrawer}>
        {editInvestment ? (
          <EditInvestment investmentId={editInvestment} toggleEdit={toggleEdit} />
        ) : addBalance ? (
          <AddBalance investmentId={addBalance} toggleAdd={toggleAdd} />
        ) : null}
      </Drawer>
    </div>
  )
}

export default withRouterProps(
  inject('account', 'store')(observer(InstitutionalInvestmentsDisplay))
)
